import { releaseNotes } from '../data/releaseNotes';

export const isNewerVersion = (a, b) => {
  if (!b) return true;
  const [aMajor, aMinor, aPatch] = a.split('.').map(Number);
  const [bMajor, bMinor, bPatch] = b.split('.').map(Number);
  if (aMajor !== bMajor) return aMajor > bMajor;
  if (aMinor !== bMinor) return aMinor > bMinor;
  return aPatch > bPatch;
};

export const getLatestReleaseVersion = () => releaseNotes[0]?.version ?? null;
